import React, { FC } from 'react';
import Select, { GroupBase, ActionMeta, InputActionMeta, OptionsOrGroups, SingleValue } from 'react-select';
import classNames from 'classnames';
import { SelectComponents } from 'react-select/dist/declarations/src/components';
import { controlStyles, optionStyles } from '../styles/selectStyles';
import { Option } from '../interfaces/option.interface';
import './styles.scss';

interface DropdownInputProps {
  className?: string;
  components?: Partial<SelectComponents<Option, false, GroupBase<Option>>> | undefined;
  inputValue?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
  isInvalid?: boolean;
  isLoading?: boolean;
  noOptionsMessage?: (obj: { inputValue: string }) => React.ReactNode;
  onChange?: (newValue: SingleValue<Option>, actionMeta: ActionMeta<Option>) => void;
  onInputChange?: (newValue: string, actionMeta: InputActionMeta) => void;
  options?: OptionsOrGroups<Option, GroupBase<Option>>;
  placeholder?: string;
  value?: Option;
  wrapperClassName?: string;
}

export const DropdownInput: FC<DropdownInputProps> = ({
  className,
  inputValue,
  isClearable,
  onChange,
  onInputChange,
  options,
  placeholder,
  wrapperClassName,
  noOptionsMessage,
  value,
  isDisabled,
  isInvalid,
  isLoading,
  components,
}) => {
  return (
    <div className={classNames('dropdown-input-select', wrapperClassName)}>
      <Select<Option>
        styles={{
          control: base => controlStyles(base, isInvalid),
          option: optionStyles,
        }}
        isClearable={isClearable}
        className={classNames(className)}
        onChange={onChange}
        onInputChange={onInputChange}
        options={options}
        isLoading={isLoading}
        value={value}
        placeholder={placeholder}
        inputValue={inputValue}
        isDisabled={isDisabled}
        noOptionsMessage={noOptionsMessage}
        components={{
          IndicatorSeparator: () => null,
          ...components,
        }}
      />
    </div>
  );
};
